"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const EtudeError_1 = require("../error/EtudeError");
const CircularIterator_1 = require("../util/CircularIterator");
const CircularStream_1 = require("../util/CircularStream");
const Exceptional_1 = require("../util/Exceptional");
const MathUtil_1 = require("../util/MathUtil");
const Direction_1 = require("./Direction");
class Letter {
    constructor(offset) {
        this.offset = offset;
        ++Letter.size;
        Letter._values.push(this);
    }
    static values() {
        return Letter._values.slice();
    }
    ordinal() {
        return Letter._values.indexOf(this);
    }
    static valueOf(letterString) {
        const letter = Letter[letterString];
        if (letter instanceof Letter) {
            return letter;
        }
        throw EtudeError_1.default.forInvalid(Letter, letterString);
    }
    getOffset() {
        return this.offset;
    }
    static getLetters(direction = Direction_1.default.DEFAULT, startingLetter = Letter.A) {
        if (direction instanceof Letter) {
            if (arguments.length !== 1) {
                throw EtudeError_1.default.forIllegalArgument(Letter, direction, "Invalid number of arguments");
            }
            startingLetter = direction;
            direction = Direction_1.default.DEFAULT;
        }
        const letters = Letter._values.slice();
        if (direction === Direction_1.default.DESCENDING) {
            letters.reverse();
        }
        MathUtil_1.default.rotate(letters, letters.indexOf(startingLetter));
        return letters;
    }
    static stream(direction = Direction_1.default.DEFAULT, startingLetter = Letter.A) {
        if (direction instanceof Letter) {
            if (arguments.length !== 1) {
                throw EtudeError_1.default.forIllegalArgument(Letter, direction, "Invalid number of arguments");
            }
            startingLetter = direction;
            direction = Direction_1.default.DEFAULT;
        }
        return CircularStream_1.default.of(Letter.getLetters(direction, startingLetter));
    }
    static iterator(direction = Direction_1.default.DEFAULT, startingLetter = Letter.A) {
        if (direction instanceof Letter) {
            if (arguments.length !== 1) {
                throw EtudeError_1.default.forIllegalArgument(Letter, direction, "Invalid number of arguments");
            }
            startingLetter = direction;
            direction = Direction_1.default.DEFAULT;
        }
        return CircularIterator_1.default.of(Letter.getLetters(direction, startingLetter));
    }
    static isValid(letterChar) {
        const value = letterChar.toUpperCase().charCodeAt(0);
        return value >= 'A'.charCodeAt(0) && value <= 'G'.charCodeAt(0);
    }
    static fromChar(letterChar) {
        return Exceptional_1.default
            .of(letterChar)
            .filter(Letter.isValid, EtudeError_1.default.forInvalid(Letter, letterChar))
            .map(c => Letter._values[c.toUpperCase().charCodeAt(0) - 'A'.charCodeAt(0)]);
    }
    toString() {
        return Object.keys(Letter).find(l => Letter[l] === this);
    }
}
Letter.size = 0;
Letter._values = [];
/**
 * Values derived from General MIDI's program numbers
 * (https://en.wikipedia.org/wiki/General_MIDI)
 * and the octave convention for scientific pitch notation
 * (https://en.wikipedia.org/wiki/Scientific_pitch_notation)
 * Ex. The E (E4) above middle C (C4):
 *   - new octaves start on C
 *   - C4's program number is 48
 *   - increment that value by Letter.E's offset value (4)
 *   - E4: 48 + 4 == 52 == E4's program number
 */
Letter.A = new Letter(9);
Letter.B = new Letter(11);
Letter.C = new Letter(0);
Letter.D = new Letter(2);
Letter.E = new Letter(4);
Letter.F = new Letter(5);
Letter.G = new Letter(7);
exports.default = Letter;
